import React from 'react';
import { motion } from 'framer-motion';
import { FiMail, FiLinkedin, FiGithub, FiYoutube, FiMusic } from 'react-icons/fi';
import { FaSpotify } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const socialLinks = [
    { name: 'LinkedIn', href: 'https://www.linkedin.com/in/rooshhilpatel', icon: <FiLinkedin />, colorClass: 'linkedin' },
    { name: 'GitHub', href: 'https://github.com/RooshhilPatel', icon: <FiGithub />, colorClass: 'github' },
    { name: 'YouTube', href: 'https://www.youtube.com/channel/UCIOVvX83akcwueAKprDA7Xg', icon: <FiYoutube />, colorClass: 'youtube' },
    { name: 'SoundCloud', href: 'https://soundcloud.com/rrushbeats', icon: <FiMusic />, colorClass: 'soundcloud' },
    { name: 'Spotify', href: 'https://open.spotify.com/artist/1Fe2eMK6vj99x591uKcc9A', icon: <FaSpotify />, colorClass: 'spotify' },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.3 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.5, y: 20 },
    show: { opacity: 1, scale: 1, y: 0, transition: { type: 'spring', stiffness: 200, damping: 15 } }
  };

  return (
    <div className="contact-container">
      <motion.div
        className="contact-card glass-panel"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true, margin: "-50px" }}
      >
        <div className="contact-header">
          <h2 className="text-gradient">Let's Connect</h2>
          <p>Have a project in mind or just want to chat?</p>
        </div>

        <motion.a
          href="mailto:rushil.patel14@gmail.com?Subject=Hello%20Rooshhil"
          className="email-block skeuo-button"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <FiMail className="email-icon" />
          <span className="email-text">Rushil.patel14@gmail.com</span>
        </motion.a>

        <motion.div
          className="social-links"
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          {socialLinks.map((link) => (
            <motion.a
              key={link.name}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Visit ${link.name}`}
              className={`social-btn skeuo-element ${link.colorClass}`}
              variants={itemVariants}
              whileHover={{ scale: 1.15, rotate: 5, y: -5 }}
              whileTap={{ scale: 0.9 }}
            >
              {link.icon}
            </motion.a>
          ))}
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Contact;
